import React, { useState } from "react";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import CustomButton from "../../Components/Common/CustomButton";
import InputText from "../../Components/sectioninput/formelement/InputText";
import { handleError } from "../../REDUX/actions/notifications";
import { addUser } from "../../REDUX/actions/users";

const NewUserView = () => {
  const dispatch = useDispatch();

  const [formData, setuserForm] = useState({});

  const [passwordConfirmation, setpasswordConfirmation] = useState("");
  const [isAdmin, setisAdmin] = useState(false);
  const disableForm = !formData.username || !formData.lastName || !formData.firstName || !formData.email || !formData.password || !passwordConfirmation;

  const handleChangeForm = (value, champs) => {
    setuserForm({ ...formData, [champs]: value });
  };

  const handleChangePass = (value) => {
    setpasswordConfirmation(value);
  };

  const handleIsAdmin = (e) => {
    setisAdmin(e);
  };

  const handleUpdateCredentials = () => {
    if (passwordConfirmation !== formData.password) {
      dispatch(handleError("Mot de passes différents", 1));
      // eslint-disable-next-line
    } else if (!/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,9})+$/.test(formData.email)) {
      dispatch(handleError("Adresse email invalide", 1));
    } else {
      dispatch(addUser({ ...formData, isAdmin: isAdmin }));
    }
  };

  return (
    <div className="container-fluid">
      <div className="row justify-content-center gap-5">
        <div className="col-6 bg-white rounded-10 shadowed p-5">
          <h2 className="mb-0 f24 fw-normal text-start mb-5">Informations de l'utilisateur</h2>
          <InputText labelinput="Utilisateur" handleChange={handleChangeForm} value={formData.username} champs="username" flag={false} />
          <InputText labelinput="Nom" handleChange={handleChangeForm} value={formData.lastName} champs="lastName" flag={false} />
          <InputText labelinput="Prénom" handleChange={handleChangeForm} value={formData.firstName} champs="firstName" flag={false} />
          <div className="text-start my-2">
            <label className="f16 text-start mb-1">Role</label>
            <Form.Select defaultValue={false} className="customSelect rounded-3" aria-label="Default select example mb-2" onChange={(e) => handleIsAdmin(e.target[1].selected)}>
              <option value={false}>Redacteur</option>
              <option value={true}>Administrateur</option>
            </Form.Select>
          </div>
          <div className="mt-5"></div>
        </div>

        <div className="col-5 bg-white rounded-10 shadowed p-5">
          <h2 className="mb-0 f24 fw-normal text-start mb-5">Données de connexion</h2>

          <InputText labelinput="E-mail" handleChange={handleChangeForm} value={formData.email} champs="email" flag={false} />

          <InputText labelinput="Mot de passe" type="password" handleChange={handleChangeForm} champs="password" flag={false} />
          <InputText labelinput="Confirmation du nouveau mot de passe" type="password" handleChange={handleChangePass} champs="password" flag={false} />
          <div className="mt-5">
            <CustomButton buttonText="Ajouter l'utilisateur" iconStart={"pencil"} disabled={disableForm} callBack={handleUpdateCredentials} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default NewUserView;
